/* eslint-disable require-atomic-updates */
import {Context} from '@/project'
import {TransformError} from '@/lib/axiosAddTransforms'

/**
 * Retry request with signIn when a request has 401 error
 * Retry 3 times
 * @param error
 * @param context
 * @param info
 */
const module: TransformError<Context> = async (error, context, info) => {
  const {config} = error
  if(!error.response || !context.store || !config) {
    return error
  }
  const {__noRetry = false} = info.originalConfig.data || {}
  const {status} = error.response
  const {store} = context

  if(
    status !== 401
    || error.config.baseURL === 'https://kauth.kakao.com'
    || __noRetry
  ) {
    return error
  }

  store.commit('auth/update', {accessToken: null})

  try {
    await store.dispatch('auth/connectKakao')
  } catch(e) {
    // skip error
    return error
  }

  if(typeof info.retry === 'undefined') {
    info.retry = 1
  } else {
    info.retry += 1
  }

  if(info.retry > 2) {
    info.retry = false
  }

  return error
}

export default module
